import { ArrowLink } from "~/components/ui";

export type Testimonial = { theme: string; quote: string; name: string; note: string; href: string };

type TestimonialListProps = {
  items: Testimonial[];
  /** «Ver opiniones en Facebook» */
  linkLabel: string;
  /** «(abre en otra pestaña)» — visually hidden, completes the external link's name. */
  externalLabel: string;
};

/**
 * T872 S3 — the students' experiences (October delivery `TestimonialQuote.html`,
 * `.story-grid`): a theme line, the quote in serif, the name, the provenance note and the
 * link to the public review. Three columns, one on a phone. No photos and no review
 * structured data (T823): the names and words are the approved ones, the link is the
 * proof.
 */
export function TestimonialList({ items, linkLabel, externalLabel }: TestimonialListProps) {
  if (items.length === 0) return null;
  return (
    <div className="pub-stories-grid">
      {items.map((item) => (
        <figure className="pub-story" key={item.name}>
          <p className="pub-story-theme">{item.theme}</p>
          <blockquote>{item.quote}</blockquote>
          <figcaption>
            {item.name}
            <span>{item.note}</span>
            <ArrowLink
              className="pub-story-link"
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              icon={
                <svg
                  className="pub-external-icon"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M14 4h6v6M20 4 10 14M10 4H4v16h16v-6" />
                </svg>
              }
            >
              {linkLabel}
              <span className="sr-only"> {externalLabel}</span>
            </ArrowLink>
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
